import { render } from "./Disciplinary_Meetings.vue?vue&type=template&id=ab66d4fc"
import script from "./Disciplinary_Meetings.vue?vue&type=script&lang=js"
export * from "./Disciplinary_Meetings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__